import { ReactNode, useContext } from 'react'

import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'
import { AirPopulationContext } from '../context'

type Props = {
  colLeft: ReactNode
  colRight: ReactNode
} & BoxProps

export const Layout = ({
  colLeft,
  colRight,
  styles,
  classNames,
  className,
  ...rest
}: Props) => {
  const { size, backgroundColor } = useContext(AirPopulationContext)
  const { classes, cx } = useStyles(
    { size, backgroundColor },
    {
      name: 'AirPopulation__Layout',
      styles,
      classNames,
    },
  )

  return (
    <Box {...rest} className={cx(className, classes.root)}>
      <Box className={classes.colLeft}>{colLeft}</Box>
      <Box className={classes.colRight}>{colRight}</Box>
    </Box>
  )
}
